import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { isNullOrUndefined } from 'util';
// import * as moment from 'moment';
// import 'moment/locale/nl';
// import {
//   setInterval,
//   clearInterval
// } from 'timers';

@Component({
  selector: 'app-countdown-timer',
  template: '<p class="mat-display-1" style="color: #0089A8; text-align: center; margin: 0.5em; white-space: nowrap;">{{formatTime}}</p>'
})
export class CountdownTimerComponent implements OnInit, OnDestroy {

  seconds = 0;

  private _time: number;
  private _timing: number = 1000;
  private _interval: Subscription;
  private timer;
  public formatTime: string = '0';

  ngOnInit() {
  }

  start() {
    this._startTimer(true);
  }

  pause() {
    this._pauseTimer();
  }

  resume() {
    this._resumeTimer();
  }

  stop()  {
    this._stopTimer();
  }

  private _startTimer(reset: boolean = false) {
    this._clearTimer();

    if (reset) {
      this.seconds = this._time;
    }

    this.timer = Observable.timer(0 ,1000);
    this._interval = this.timer.subscribe(t => this.countdown_interval(t));

    console.log('_startTimer', this._interval);
  }

  private countdown_interval(tick){
    this.seconds -= 1;
    this.updateAndFormatTime();
    if (this.seconds === 0) {
      this._stopTimer();
    }
  }

  @Input()
  public set time(value: string | number) {
    this._time = parseInt(value as string, 10);
    this.seconds = this._time;
  }

  @Input()
  public set timing(value: string | number) {
    this._timing = parseInt(value as string, 10);
  }

  @Input()
  public format: string = '{mm} : {ss}';



  public updateAndFormatTime() {
    let days, hours, minutes, seconds, delta = this.seconds, time = this.format;

    days = Math.floor(delta / 86400);
    delta -= days * 86400;
    hours = Math.floor(delta  / 3600) % 24;
    delta -= hours * 3600;
    minutes = Math.floor(delta  / 60) % 60;
    delta -= minutes * 60;
    seconds = delta % 60;

    if (minutes < 10) {
      minutes = '0' + minutes;
    }

    if (seconds < 10) {
      seconds = '0' + seconds;
    }

    time = time.replace('{dd}', days);
    time = time.replace('{hh}', hours);
    time = time.replace('{mm}', minutes);
    time = time.replace('{ss}', seconds);

    this.formatTime = time;
    // console.log(this.formatTime);
    return time;
  }

  constructor() { }

  ngOnDestroy() {
    console.log('ngOnDestroy');

    this._clearTimer();
    this.seconds = 0;
  }

  private _stopTimer() {
    this._clearTimer();
    this.seconds = 0;
  }
  private _pauseTimer() {
    this.timer = null;
    if (!isNullOrUndefined(this._interval)) {
      this._interval.unsubscribe();
    }
  }

  private _resumeTimer() {
    if (this.seconds > 0) {
      this._startTimer();
    }
  }

  private _clearTimer() {
    this._pauseTimer();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/countdown-timer/countdown-timer.component.ts